import { css } from 'emotion';

export const list = css`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: inline-block;
    margin-bottom: 10px;
  }
`;

export const item = css`
  margin-right: 5px;
`;
